import React from 'react';
import ExitIcon from '@moda/icons/exit-16';
import classNames from 'classnames';
import { Clickable } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { useAuthMethod } from '../../hooks/useAuth';
import { PasswordlessAuthentication } from './PasswordlessAuthentication';

import './Authentication.scss';

export type DefaultValues = {
  registerEmail?: string;
  registerEmailList?: boolean;
  signInEmail?: string;
  signInRemember?: boolean;
};

export type AuthenticationProps = {
  fullPage?: boolean;
  modal?: boolean;
  defaultValues?: DefaultValues;
  onAuth?: () => void;
  showAuthModal?: () => void;
  hideAuthModal?: () => void;
};

export const Authentication: React.FC<AuthenticationProps> = ({
  fullPage = false,
  modal = false,
  defaultValues,
  onAuth = noop,
  showAuthModal,
  hideAuthModal
}) => {
  useAuthMethod({ authLocation: 'standard_login' });

  return (
    <div
      className={classNames('Authentication', {
        'Authentication--fullPage': fullPage,
        'Authentication--modal': modal
      })}
      data-testid="authentication"
    >
      {modal && hideAuthModal ? (
        <Clickable aria-label="Close" className="Authentication__close" onClick={hideAuthModal}>
          <ExitIcon />
        </Clickable>
      ) : null}
      <PasswordlessAuthentication
        defaultValues={defaultValues}
        fullPage={fullPage}
        hideAuthModal={hideAuthModal}
        modal={modal}
        onAuth={onAuth}
        showAuthModal={showAuthModal}
      />
    </div>
  );
};
